const Algorithms = {
  AES_256_CBC: 'http://www.w3.org/2001/04/xmlenc#aes256-cbc',
  AES_256_GCM: 'http://www.w3.org/2009/xmlenc11#aes256-gcm',
};
module.exports = Algorithms;
